import { ContributionProjetRepository } from '../repositories/ContributionProjetRepository';
import { ListerContributionsParEmployeUseCase } from '../../application/use-cases/ListerContributionsParEmployeUseCase';
import { ListerContributionsParProjetUseCase } from '../../application/use-cases/ListerContributionsParProjetUseCase';
import { CreerContributionUseCase } from '../../application/use-cases/CreerContributionUseCase';
import { ModifierContributionUseCase } from '../../application/use-cases/ModifierContributionUseCase';
import { SupprimerContributionUseCase } from '../../application/use-cases/SupprimerContributionUseCase';

const repository = new ContributionProjetRepository();

export const container = {
  listerParEmployeUseCase:  new ListerContributionsParEmployeUseCase(repository),
  listerParProjetUseCase:   new ListerContributionsParProjetUseCase(repository),
  creerContributionUseCase: new CreerContributionUseCase(repository),
  modifierContributionUseCase: new ModifierContributionUseCase(repository),
  supprimerContributionUseCase: new SupprimerContributionUseCase(repository),
} as const;

export type Container = typeof container;
